import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "serviceUnlocked"
const ServiceUnlockedIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="m7 8v-1a5 5 0 1 1 10 0v3c1.105.003 2 .904 2 2.009v6.982c0 1.11-.897 2.009-2.006 2.009h-9.988a2.009 2.009 0 0 1 -2.006-2.009v-6.981c0-1.11.894-2.007 2-2.01h8v-3a3 3 0 0 0 -6 0v1z" />
        </svg>
      }
    </span>
  )
}
export default ServiceUnlockedIcon
